import * as React from "react";
import PropTypes from "prop-types";
const SvgBadgesMulticolorSummitXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FEFEFE"
          d="M.563.666C.39.374.596 0 .93 0h9.814c.074 0 .144.04.183.106l4.68 7.895-4.68 7.894a.216.216 0 01-.183.106H.93c-.334 0-.54-.374-.367-.666L4.91 8 .563.666z"
        />
        <path
          fill="#FC4C02"
          d="M14.514 8l-4.113-6.786a.446.446 0 00-.38-.214h-7.84a.222.222 0 00-.19.338L6.03 8h8.485z"
        />
        <path
          fill="#CF4017"
          d="M1.992 14.663L6.03 8h8.485l-4.113 6.786a.446.446 0 01-.38.214h-7.84a.223.223 0 01-.19-.338"
        />
      </g>
    </svg>
  )
);
SvgBadgesMulticolorSummitXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgBadgesMulticolorSummitXsmall;
